import React from 'react';
import clsx from 'clsx';

interface PositionControlSquareProps {
  className?: string;
  onClick?: () => void;
  disabled: boolean;
  value?: boolean;
}

export const PositionControlSquare: React.FC<PositionControlSquareProps> = ({
  className = '',
  onClick,
  disabled = false,
  value,
}) => {
  const handleClick = () => {
    if (!disabled) {
      if (onClick) onClick();
    }
  };

  return (
    <div
      onClick={handleClick}
      className={clsx(
        'h-5 w-7 rounded border transition-all',
        {
          'border-indigo-400 bg-indigo-50': value === true && disabled === false,
          'bg-neutral-10 border-neutral-200': value === false || disabled === true,
          'cursor-default': disabled === true,
          'cursor-pointer': disabled === false,
        },
        className,
      )}
    />
  );
};
